<template>
  <vue-easy-lightbox
    :visible="lightboxVisible"
    :imgs="lightboxImgs"
    :index="lightboxIndex"
    @hide="onHideLightbox"
  ></vue-easy-lightbox>
  <div v-if="show" class="modal-backdrop fade show"></div>
  <div :class="['modal', 'fade', { show: show }]" role="dialog">
    <div
      v-if="!isTaskHistory"
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      :class="isViewMode ? ' modal-xl' : 'modal-lg'"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            {{ modalTitle }}
          </h4>
          <div>
            <button
              v-if="isViewMode"
              type="button"
              class="btn btn-light mr-2"
              @click="toggleTaskHistory()"
            >
              <i class="las la-history"></i>
              Lịch sử hoạt động
            </button>

            <button
              type="button"
              class="close"
              @click="closeModal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

        <div class="modal-body row d-flex">
          <div
            class="p-3 task-details-column"
            :class="isViewMode ? 'col-lg-7 border-right' : 'col-lg-12'"
          >
            <div class="d-flex flex-row-reverse">
              <button
                v-if="isViewMode"
                type="button"
                class="btn btn-primary"
                @click="emit('switchToEditMode')"
              >
                Sửa nhiệm vụ
              </button>
            </div>
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="taskTitle"
                  >Tên nhiệm vụ <span class="text-danger">*</span></label
                >
                <input
                  id="taskTitle"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': titleError }"
                  v-model="editableTask.title"
                  placeholder="Ví dụ: Thiết kế giao diện trang chủ..."
                  :disabled="isViewMode"
                />
                <div v-if="titleError" class="invalid-feedback">
                  {{ titleError }}
                </div>
              </div>

              <div class="form-group">
                <label for="taskDescription">Mô tả</label>
                <textarea
                  id="taskDescription"
                  rows="4"
                  class="form-control"
                  v-model="editableTask.description"
                  placeholder="Thêm mô tả chi tiết cho nhiệm vụ..."
                  :disabled="isViewMode"
                ></textarea>
              </div>
              <div class="form-group d-flex align-items-center">
                <label for="thongBao">Nhắc nhở 7 giờ hàng ngày</label>
                <input
                  id="thongBao"
                  type="checkbox"
                  v-model="editableTask.guiThongBaoHangNgay"
                  :disabled="isViewMode"
                  class="task-checkbox form-control"
                />
              </div>
              <div
                class="form-group d-flex align-items-center justify-content-between bg-light p-2 rounded border"
              >
                <label class="mb-0"> Thiết lập thời hạn </label>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="deadlineSwitch"
                    v-model="hasDeadline"
                    :disabled="isViewMode"
                  />
                  <label class="custom-control-label" for="deadlineSwitch">
                    {{ hasDeadline ? "Đang bật" : "Không thời hạn" }}
                  </label>
                </div>
              </div>

              <div v-if="hasDeadline" class="row date-picker-container mb-3">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="startDate" class="small text-muted"
                      >Ngày bắt đầu</label
                    >
                    <input
                      id="startDate"
                      class="form-control"
                      type="datetime-local"
                      v-model="editableTask.ngayBatDau"
                      :disabled="isViewMode"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="endDate" class="small text-muted">
                      Ngày hết hạn
                      <div v-if="!isViewMode" class="btn-group ml-1">
                        <button
                          type="button"
                          class="btn btn-xs btn-outline-secondary py-0"
                          @click="addTime(15)"
                        >
                          +15m
                        </button>
                        <button
                          type="button"
                          class="btn btn-xs btn-outline-secondary py-0"
                          @click="addTime(60)"
                        >
                          +1h
                        </button>
                      </div>
                    </label>
                    <input
                      id="endDate"
                      class="form-control"
                      type="datetime-local"
                      v-model="editableTask.thoiHan"
                      :disabled="isViewMode"
                      :class="{ 'is-invalid': !editableTask.thoiHan }"
                    />
                    <div class="invalid-feedback" v-if="!editableTask.thoiHan">
                      Vui lòng chọn hạn chót.
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>File đính kèm</label>

                <div
                  v-if="
                    editableTask.attachments &&
                    editableTask.attachments.length > 0
                  "
                  class="attachment-previews-grid mb-2"
                >
                  <div
                    v-for="(file, index) in editableTask.attachments"
                    :key="file.id || file.fileUrl"
                    class="attachment-preview-item"
                  >
                    <a
                      v-if="file.fileType && file.fileType.startsWith('image/')"
                      @click="showImagePreview(editableTask.attachments, file)"
                      class="attachment-thumbnail"
                    >
                      <img :src="file.fileUrl" :alt="file.originalFileName" />
                    </a>
                    <a
                      v-else-if="file.fileType === 'application/pdf'"
                      :href="file.fileUrl"
                      target="_blank"
                      class="file-icon-preview"
                      title="Nhấn để mở file PDF"
                    >
                      <i class="fa fa-file-pdf-o fa-2x text-danger"></i>
                      <span class="file-name">{{ file.originalFileName }}</span>
                    </a>

                    <a
                      v-else-if="
                        file.fileType && file.fileType.startsWith('video/')
                      "
                      class="attachment-thumbnail"
                    >
                      <video
                        :src="file.fileUrl"
                        controls
                        class="img-fluid rounded mb-2"
                      ></video>
                    </a>

                    <a
                      v-else
                      href="#"
                      @click.stop.prevent="downloadFile(file)"
                      class="file-icon-preview"
                    >
                      <i :class="getFileIconClass(file.fileType)"></i>
                      <span class="file-name">{{ file.originalFileName }}</span>
                    </a>
                    <div class="file-actions-overlay">
                      <button
                        v-if="isViewMode && canShare"
                        type="button"
                        @click.stop.prevent="shareFile(file)"
                        class="btn-file-action btn-share-action"
                        v-tooltip="'Chia sẻ'"
                      >
                        <i class="fa fa-share-alt"></i>
                      </button>

                      <a
                        href="#"
                        @click.stop.prevent="downloadFile(file)"
                        class="btn-file-action"
                        v-tooltip="'Tải xuống'"
                      >
                        <i class="fa fa-download"></i>
                      </a>
                    </div>
                    <button
                      v-if="!isViewMode"
                      type="button"
                      @click="removeExistingAttachment(file)"
                      class="attachment-remove-btn"
                    >
                      &times;
                    </button>
                  </div>
                </div>

                <div
                  v-if="newlySelectedFiles.length > 0"
                  class="attachment-previews-grid mb-2"
                >
                  <div
                    v-for="(file, index) in newlySelectedFiles"
                    :key="index"
                    class="attachment-preview-item"
                  >
                    <div class="file-icon-preview">
                      <i class="fa fa-file-o fa-2x text-muted"></i>
                      <span class="file-name">{{ file.name }}</span>
                    </div>
                    <button
                      type="button"
                      @click="removeNewFile(index)"
                      class="attachment-remove-btn"
                    >
                      &times;
                    </button>
                  </div>
                </div>

                <div v-if="!isViewMode">
                  <div
                    class="file-drop-zone"
                    :class="{ 'drag-over': isDragOver }"
                    @dragover.prevent="isDragOver = true"
                    @dragleave.prevent="isDragOver = false"
                    @drop.prevent="handleFileDrop"
                    @paste="handlePaste"
                    tabindex="0"
                  >
                    <p class="text-muted mb-2">
                      Kéo thả file vào đây, dán (Paste) hoặc
                    </p>

                    <button
                      type="button"
                      class="btn btn-light btn-sm"
                      @click="triggerTaskFileInput"
                      :disabled="isUploading"
                    >
                      <i class="fa fa-plus"></i> Chọn file
                    </button>

                    <input
                      type="file"
                      ref="taskFileInput"
                      @change="handleFileSelection"
                      class="d-none"
                      multiple
                    />
                  </div>

                  <div
                    v-if="isUploading"
                    class="spinner-border spinner-border-sm ml-2 mt-2"
                    role="status"
                  >
                    <span class="sr-only">Đang tải lên...</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="priority">Độ ưu tiên</label>
                <select
                  id="priority"
                  class="form-control"
                  v-model="editableTask.priority.key"
                  :disabled="isViewMode"
                >
                  <option
                    v-for="p in availablePriorities"
                    :key="p.key"
                    :value="p.key"
                  >
                    {{ p.text }}
                  </option>
                </select>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="difficulty">Độ khó</label>
                    <select
                      id="difficulty"
                      class="form-control"
                      v-model="editableTask.doKho"
                      :disabled="isViewMode"
                    >
                      <option :value="null">-- Chọn độ khó --</option>
                      <option value="EASY">Dễ</option>
                      <option value="MEDIUM">Vừa</option>
                      <option value="HARD">Khó</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Thẻ Tags</label>
                    <vue-multiselect
                      v-model="selectedTags"
                      :options="[]"
                      :multiple="true"
                      :taggable="true"
                      @tag="addTag"
                      placeholder="Nhập tag và nhấn Enter"
                      tag-placeholder="Nhấn Enter để tạo thẻ mới"
                      :disabled="isViewMode"
                      :close-on-select="false"
                    >
                    </vue-multiselect>
                    <small class="form-text text-muted" v-if="!isViewMode"
                      >Nhập tên thẻ rồi nhấn Enter để thêm.</small
                    >
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>Thành viên thực hiện</label>
                <vue-multiselect
                  v-model="editableTask.assignedUsers"
                  :options="allUsers"
                  :multiple="true"
                  :close-on-select="false"
                  placeholder="Tìm và chọn thành viên"
                  label="hoTen"
                  track-by="idNguoiDung"
                  :disabled="isViewMode"
                  deselect-label="Nhấn Enter để bỏ chọn"
                  select-label="Nhấn Enter để chọn"
                  selected-label="Đã chọn"
                >
                  <template #option="{ option }">
                    <span class="option__title">{{ option.hoTen }}</span>
                  </template>
                </vue-multiselect>
              </div>
            </form>
          </div>

          <div
            v-if="isViewMode"
            class="col-lg-5 activity-feed-column"
            ref="activityFeedColumn"
          >
            <div class="text-muted small mb-3">
              Nhiệm vụ được tạo vào lúc
              {{ formatTimestamp(editableTask.ngayTao) }}
            </div>

            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5 class="mb-0">Nhận xét và Hoạt động</h5>
              <button
                class="btn btn-light btn-sm dropdown-toggle"
                type="button"
                data-toggle="dropdown"
              >
                {{ mapCommentType(filterType) }}
              </button>
              <div class="dropdown-menu">
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="
                    (filterType = 'ALL'), (actionType = 'COMMENT')
                  "
                >
                  {{ mapCommentType("ALL") }}
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="
                    (filterType = 'COMMENT'), (actionType = 'COMMENT')
                  "
                >
                  {{ mapCommentType("COMMENT") }}
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="
                    (filterType = 'REPORT'), (actionType = 'REPORT')
                  "
                >
                  {{ mapCommentType("REPORT") }}
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="
                    (filterType = 'PROPOSAL'), (actionType = 'PROPOSAL')
                  "
                >
                  {{ mapCommentType("PROPOSAL") }}
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="
                    (filterType = 'URGENT'), (actionType = 'URGENT')
                  "
                >
                  {{ mapCommentType("URGENT") }}
                </a>
              </div>
            </div>

            <div class="new-comment-form media mb-4">
              <a href="#" v-if="me.avatarUrl" class="avatar"
                ><img alt="" :src="me.avatarUrl"
              /></a>
              <div v-else-if="me.hoTen" class="avatar-placeholder mr-3">
                <span>{{ me.hoTen.substring(0, 2).toUpperCase() }}</span>
              </div>
              <div class="media-body">
                <form
                  @submit.prevent="addComment"
                  @dragover.prevent="isCommentDragOver = true"
                  @dragleave.prevent="isCommentDragOver = false"
                  @drop.prevent="handleCommentFileDrop"
                  class="comment-drop-zone"
                  :class="{ 'drag-over': isCommentDragOver }"
                >
                  <div class="comment-input-wrapper">
                           
                    <editor-content :editor="editor" @paste="handlePaste" />    
                     
                  </div>

                  <div
                    v-if="newlySelectedCommentFiles.length > 0"
                    class="attachment-preview-container mt-2"
                  >
                    <div
                      v-for="(file, index) in newlySelectedCommentFiles"
                      :key="index"
                      class="attachment-preview"
                    >
                      <div class="file-preview">
                        <i class="fa fa-file-text-o"></i> {{ file.name }}
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm btn-danger attachment-remove-btn"
                        @click="removeNewCommentFile(index)"
                      >
                        &times;
                      </button>
                    </div>
                  </div>

                  <div
                    class="comment-actions mt-2 d-flex justify-content-between align-items-center"
                  >
                    <div class="d-flex align-items-center">
                      <button
                        type="button"
                        class="btn btn-light btn-sm"
                        title="Đính kèm file"
                        @click="triggerCommentFileInput"
                      >
                        <i class="fa fa-paperclip"></i>
                      </button>
                      <input
                        type="file"
                        ref="commentFileInputRef"
                        @change="handleCommentFileSelection"
                        class="d-none"
                        multiple
                      />
                      <div class="dropdown action-type-selector ml-2">
                        <button
                          class="btn btn-light btn-sm dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                        >
                          Tạo {{ mapCommentType(actionType) }}
                        </button>
                        <div class="dropdown-menu">
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="
                              (actionType = 'COMMENT'), (filterType = 'ALL')
                            "
                          >
                            Tạo {{ mapCommentType("COMMENT") }}
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="
                              (actionType = 'REPORT'), (filterType = 'REPORT')
                            "
                          >
                            Tạo {{ mapCommentType("REPORT") }}
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="
                              (actionType = 'PROPOSAL'),
                                (filterType = 'PROPOSAL')
                            "
                          >
                            Tạo {{ mapCommentType("PROPOSAL") }}
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="
                              (actionType = 'URGENT'), (filterType = 'URGENT')
                            "
                          >
                            Tạo {{ mapCommentType("URGENT") }}
                          </a>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary btn-sm"
                      :disabled="
                        isUploadingCommentFiles || (editor && editor.isEmpty)
                      "
                    >
                      <span
                        v-if="isUploadingCommentFiles"
                        class="spinner-border spinner-border-sm"
                        role="status"
                      ></span>
                      Gửi
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div class="activity-feed-list">
              <div
                v-for="item in displayedActivities"
                :key="item.id"
                class="media mb-3"
              >
                <div v-if="item.user.avatar" class="avatar mr-3">
                  <img :src="item.user.avatar" />
                </div>
                <div v-else-if="item.user.name" class="avatar-placeholder mr-3">
                  <span>{{
                    item.user.name.substring(0, 2).toUpperCase()
                  }}</span>
                </div>

                <div class="media-body">
                  <div class="d-flex justify-content-between">
                    <div class="item-header">
                      <strong class="mr-1">{{ item.user.name }}</strong>
                      <span class="text-muted small">
                        <span v-if="item.corrected">
                          <i class="la la-history"></i> Đã sửa:
                          {{ item.timesupdate }}
                        </span>
                        <span v-else>{{ item.timestamp }}</span>
                        <span
                          v-if="item.type === 'REPORT'"
                          class="activity-tag activity-tag-report"
                          >Báo cáo: Cột "{{ item.workColumn?.tenCot }}"</span
                        >
                        <span
                          v-if="item.type === 'PROPOSAL'"
                          class="activity-tag activity-tag-proposal"
                          >Đề xuất: Cột "{{ item.workColumn?.tenCot }}"</span
                        >
                        <span
                          v-if="item.type === 'URGENT'"
                          class="activity-tag activity-tag-urgent"
                          >Khẩn cấp: Cột "{{ item.workColumn?.tenCot }}"</span
                        >
                      </span>
                    </div>
                    <i
                      v-if="item.isPinned"
                      class="fa fa-thumb-tack text-primary"
                      title="Đã ghim"
                    ></i>
                  </div>

                  <div
                    v-if="item.type === 'activity'"
                    class="activity-content mt-1 text-muted"
                  >
                    <em>{{ item.actionText }}</em>
                  </div>

                  <div v-else>
                    <div v-if="editingCommentId !== item.id">
                      <div
                        class="comment-content card mt-1 mb-0"
                        :class="[
                          {
                            pinned: item.isPinned,
                            'comment--glow': +item.id === +highlightedCommentId,
                          },
                          getActivityItemClass(item),
                        ]"
                        :data-comment-id="item.id"
                        :id="`comment-${item.id}`"
                      >
                        <div class="card-body p-2">
                          <p
                            class="comment-content mb-1"
                            v-if="item.content"
                            v-html="item.content"
                          ></p>

                          <div
                            v-if="item.attachments && item.attachments.length"
                            class="comment-attachment mt-2"
                          >
                            <div
                              v-for="(file, index) in item.attachments"
                              :key="index"
                            >
                              <a
                                v-if="file.fileType.startsWith('image/')"
                                href="#"
                                @click.prevent="
                                  showImagePreview(item.attachments, file)
                                "
                              >
                                <img
                                  :src="file.fileUrl"
                                  class="img-fluid rounded mb-2"
                                  alt="Preview"
                                />
                              </a>
                              <video
                                v-else-if="file.fileType.startsWith('video/')"
                                :src="file.fileUrl"
                                controls
                                class="comment-attachment-video img-fluid rounded mb-2"
                              ></video>
                              <a
                                v-else-if="file.fileType === 'application/pdf'"
                                :href="file.fileUrl"
                                target="_blank"
                              >
                                <div class="file-attachment mb-2 text-center">
                                  <i
                                    class="fa fa-file-pdf-o"
                                    style="font-size: 3rem; color: #d9534f"
                                  ></i>
                                  <span class="d-block small">{{
                                    file.originalFileName
                                  }}</span>
                                </div>
                              </a>
                              <a
                                v-else
                                href="#"
                                @click.stop.prevent="downloadFile(file)"
                                :title="file.originalFileName"
                              >
                                <div
                                  v-if="file.fileType.includes('word')"
                                  class="file-attachment mb-2 text-center"
                                >
                                  <i
                                    class="fa fa-file-word-o"
                                    style="font-size: 3rem; color: #2a5699"
                                  ></i>
                                  <span class="d-block small">{{
                                    file.originalFileName
                                  }}</span>
                                </div>
                                <div
                                  v-else-if="file.fileType.includes('excel')"
                                  class="file-attachment mb-2 text-center"
                                >
                                  <i
                                    class="fa fa-file-excel-o"
                                    style="font-size: 3rem; color: #1d6f42"
                                  ></i>
                                  <span class="d-block small">{{
                                    file.originalFileName
                                  }}</span>
                                </div>
                                <div v-else class="file-attachment mb-2">
                                  <i class="fa fa-file-text-o"></i>
                                  {{ file.originalFileName }}
                                </div>
                              </a>
                              <div class="file-actions-overlay">
                                <button
                                  v-if="canShare"
                                  type="button"
                                  @click.stop.prevent="shareFile(file)"
                                  class="btn-file-action btn-share-action"
                                  v-tooltip="'Chia sẻ'"
                                >
                                  <i class="fa fa-share-alt"></i>
                                </button>

                                <a
                                  href="#"
                                  @click.stop.prevent="downloadFile(file)"
                                  class="btn-file-action"
                                  v-tooltip="'Tải xuống'"
                                >
                                  <i class="fa fa-download"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-end action-links small text-muted mt-2 mb-2"
                        v-if="
                          me.hoTen === item.user.name ||
                          (canShare &&
                            item.attachments &&
                            item.attachments.length > 0)
                        "
                      >
                        <a
                          v-if="
                            canShare &&
                            item.attachments &&
                            item.attachments.length > 1
                          "
                          href="#"
                          class="mr-3"
                          @click.prevent="shareMultipleFiles(item)"
                          title="Chia sẻ tất cả file đính kèm"
                        >
                          <i
                            class="fa fa-share-alt-square"
                            aria-hidden="true"
                          ></i>
                          Gửi {{ item.attachments.length }} file
                        </a>
                        <template v-if="me.hoTen === item.user.name">
                          <a
                            href="#"
                            @click.prevent="togglePinComment(item.id)"
                          >
                            <i class="la la-thumbtack"></i>
                            {{ item.isPinned ? " Bỏ ghim" : " Ghim" }}
                          </a>
                          <a
                            class="ml-3"
                            href="#"
                            @click.prevent="startEdit(item)"
                          >
                            <i class="fa fa-pencil"></i> Sửa
                          </a>
                          <a
                            class="ml-3"
                            href="#"
                            @click.prevent="deleteComment(item.id)"
                          >
                            <i class="fa fa-trash-o"></i> Xoá
                          </a>
                        </template>
                      </div>
                    </div>

                    <div v-else>
                      <form @submit.prevent="saveEdit(item)">
                        <editor-content :editor="editEditor" class="mt-1" />
                        <div class="mt-2">
                          <button type="submit" class="btn btn-success btn-sm">
                            Lưu
                          </button>
                          <button
                            type="button"
                            class="btn btn-light btn-sm ml-2"
                            @click="cancelEdit"
                          >
                            Hủy
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="totalPages > 1"
              class="d-flex justify-content-center align-items-center"
            >
              <nav>
                <ul class="pagination mb-0">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 0 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="goToPage(currentPage - 1)"
                      >Trước</a
                    >
                  </li>
                  <li
                    class="page-item"
                    v-for="page in visiblePages"
                    :key="page"
                    :class="{ active: currentPage === page - 1 }"
                  >
                    <a
                      v-if="page !== '...'"
                      class="page-link"
                      href="#"
                      @click.prevent="goToPage(page - 1)"
                      >{{ page }}</a
                    >
                    <span v-else class="page-link">...</span>
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages - 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="goToPage(currentPage + 1)"
                      >Sau</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            {{ isViewMode ? "Đóng" : "Hủy" }}
          </button>
          <button
            v-if="!isViewMode"
            type="button"
            class="btn btn-primary"
            @click="handleSubmit"
          >
            {{ mode === "edit" ? "Lưu thay đổi" : "Tạo Nhiệm vụ" }}
          </button>
        </div>
      </div>
    </div>

    <div
      v-else
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
      :class="isViewMode ? ' modal-xl' : 'modal-lg'"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Lịch sử hoạt động</h4>
          <div>
            <button
              type="button"
              class="btn btn-light mr-2"
              @click="toggleTaskHistory()"
            >
              Xem nhiệm vụ
            </button>
            <button
              type="button"
              class="close"
              @click="closeModal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-3 task-details-column">
            <ActivityTaskHistory :task-id="editableTask.id" />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            Đóng
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  computed,
  onUnmounted,
  defineProps,
  defineEmits,
  nextTick,
} from "vue";
import userService from "@/services/userService";
import commentService from "@/services/taskCommentService";
import fileService from "@/services/fileService";
import { useToast } from "vue-toastification";
import { useNotificationStore } from "@/stores/notificationStore";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2";
import VueEasyLightbox from "vue-easy-lightbox";
import ActivityTaskHistory from "./ActivityTaskHistory.vue";
import { useShare } from "@/composables/useShareFile";
import { useEditor, EditorContent, VueRenderer } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Mention from "@tiptap/extension-mention";
import tippy from "tippy.js";
// import "tippy.js/dist/tippy.css";
import MentionList from "./MentionList.vue";
import taskService from "@/services/taskService";
// KÍCH HOẠT logic chia sẻ
const { canShare, isSharing, shareFile, shareMultipleFiles } = useShare();

// --- Bắt thông báo fetch comment ---
const notificationStore = useNotificationStore();
const highlightedCommentId = ref(null);
const hasDeadline = ref(false);

// --- Lịch sử hoạt động của task ---
const isTaskHistory = ref(false);
function toggleTaskHistory() {
  isTaskHistory.value = !isTaskHistory.value;
}
// ----------------------------------
function isHighlighted(id) {
  return +id === +highlightedCommentId.value; // ép 2 phía về number
}

let debounceTimer = null;
// 3. THÊM LOGIC "THEO DÕI" SỰ THAY ĐỔI CỦA STORE
watch(
  () => notificationStore.notifications,
  () => {
    if (isViewMode.value) {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        console.log("📩 📩 📩 Pinia , MODEL ĐANG MỞ...  📩 📩 📩");
        fetchComments();
      }, 500); // Chờ 0.5 giây
    }
  },
  { deep: true }
);

// --- Nhận dữ liệu từ /src/views/BangPhanChiaCongViec.vue
const props = defineProps({
  show: Boolean,
  taskData: Object,
  columnId: [Number, String],
  // CHANGED: Thêm prop 'mode' để xác định trạng thái của modal
  mode: {
    type: String,
    default: "add", // 'add', 'edit', 'view'
  },
  focusCommentId: {
    type: [String, Number, null],
    default: null,
  },
});

const emit = defineEmits(["close", "save", "switchToEditMode"]);

// ---- Sử lý thêm user ---
const allUsers = ref([]); // Danh sách tất cả user để chọn
const mentionableUsers = ref([]);
const originalAssignedUsers = ref([]); // Lưu lại danh sách ban đầu để so sánh

watch(
  () => props.show,
  async (newVal) => {
    if (newVal) {
      document.body.classList.add("modal-open");
      titleError.value = "";
      isTaskHistory.value = false;
      newlySelectedFiles.value = [];
      isUploading.value = false;
      editingCommentId.value = null;
      filterType.value = "ALL";
      actionType.value = "COMMENT";
      currentPage.value = 0;
      focusedOnce.value = false;

      newlySelectedCommentFiles.value = [];
      isUploadingCommentFiles.value = false;

      try {
        const getMe = await userService.getMe();
        me.value = getMe.data.data.content[0];
        // console.log(me.value.avatarUrl);
      } catch (e) {
        console.error("Không thể tải user này:", e);
        me.value = []; // Đảm bảo allUsers là một mảng
      }
      // 1. Lấy danh sách tất cả user để hiển thị trong dropdown
      try {
        const usersResponse = await userService.getAll();
        allUsers.value = usersResponse.data.map((user) => ({
          idNguoiDung: user.idNguoiDung,
          hoTen: user.hoTen, // Chuyển username thành name
          avatarUrl: user.avatarUrl, // Đảm bảo thuộc tính avatar tồn tại
        }));
      } catch (e) {
        console.error("Failed to fetch all users:", e);
        allUsers.value = []; // Đảm bảo allUsers là một mảng
      }

      // 2. Thiết lập dữ liệu cho modal
      if (props.mode === "edit" || props.mode === "view") {
        // Chế độ Sửa/Xem: Sao chép sâu dữ liệu từ prop
        const taskDataCopy = JSON.parse(JSON.stringify(props.taskData));

        // Gán trực tiếp danh sách user từ prop vào 'assignedUsers'
        editableTask.value = {
          ...taskDataCopy,
          doKho: taskDataCopy.doKho || null,
          ngayBatDau: taskDataCopy.ngayBatDau
            ? toDatetimeLocalString(new Date(taskDataCopy.ngayBatDau))
            : null,
          thoiHan: taskDataCopy.thoiHan
            ? toDatetimeLocalString(new Date(taskDataCopy.thoiHan))
            : null,
          // Đảm bảo rằng 'assignedUsers' luôn là một mảng
          assignedUsers: taskDataCopy.users || [],
        };
        // Kiểm tra kỹ: tags có tồn tại VÀ là chuỗi không?
        if (Array.isArray(taskDataCopy.tags)) {
          selectedTags.value = [...taskDataCopy.tags];
        } else if (typeof taskDataCopy.tags === "string") {
          selectedTags.value = taskDataCopy.tags.split(",").filter((t) => t);
        } else {
          selectedTags.value = [];
        }
        // Lưu lại danh sách user ban đầu để so sánh khi cập nhật
        originalAssignedUsers.value = [...(taskDataCopy.users || [])];

        if (taskDataCopy.thoiHan) {
          hasDeadline.value = true;
        } else {
          hasDeadline.value = false;
        }

        // Lấy danh sách commnet
        fetchComments();
        fetchMentionableUsers(props.taskData.id);
        setTimeout(() => tryFocusCommentOnce(), 300);
      } else {
        // Chế độ Thêm mới: Tạo đối tượng rỗng
        const today = new Date();
        editableTask.value = {
          title: "",
          description: "",
          ngayBatDau: null,
          thoiHan: null,
          hoanThanh: false,
          priority: { key: "MEDIUM" },
          users: [], // Dùng users để nhất quán
          assignedUsers: [], // Dùng cho v-model
          createdAt: today.toISOString(),
          guiThongBaoHangNgay: false,
          doKho: null,
          tags: null,
        };
        hasDeadline.value = false;
        originalAssignedUsers.value = [];
        activities.value = [];
        mentionableUsers.value = [];
        selectedTags.value = [];
      }
    } else {
      document.body.classList.remove("modal-open");
    }
  },
  { immediate: true }
);

watch(hasDeadline, (val) => {
  if (!val) {
    // Nếu TẮT -> Xóa dữ liệu ngày tháng về null
    editableTask.value.ngayBatDau = null;
    editableTask.value.thoiHan = null;
  } else {
    // Nếu BẬT -> Tự động điền ngày hiện tại (nếu đang trống) để user đỡ phải chọn từ đầu
    if (!editableTask.value.ngayBatDau) {
      const now = new Date();
      editableTask.value.ngayBatDau = toDatetimeLocalString(now);

      // Mặc định hạn chót là ngày mai
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate());
      editableTask.value.thoiHan = toDatetimeLocalString(tomorrow);
    }
  }
});

const fetchMentionableUsers = async (taskId) => {
  try {
    // Giả sử lấy workspaceId từ route hoặc props
    const workspaceId = route.params.id;
    const columnId = props.taskData?._original?.workColumnId;

    const res = await taskService.getMentionOptions(
      workspaceId,
      columnId,
      taskId
    );

    mentionableUsers.value = res.data.map((u) => ({
      idNguoiDung: u.idNguoiDung,
      hoTen: u.hoTen,
      avatarUrl: u.avatarUrl || "/assets/img/profiles/avatar-02.jpg",
    }));
  } catch (error) {
    console.error("Lỗi lấy danh sách mention:", error);
    mentionableUsers.value = [];
  }
};

const toDatetimeLocalString = (date) => {
  if (!date) return "";
  const pad = (num) => num.toString().padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

// Hàm thêm thời gian nhanh
const addTime = (minutesToAdd) => {
  // 1. Lấy giá trị hiện tại
  const currentDueDateString = editableTask.value.thoiHan;

  // 2. Parse nó. Nếu không có (rỗng), dùng thời gian hiện tại
  let newDate;
  if (currentDueDateString) {
    newDate = new Date(currentDueDateString);
  } else {
    newDate = new Date(); // Mặc định là 'bây giờ' nếu trống
  }

  // 3. Thêm số phút
  newDate.setMinutes(newDate.getMinutes() + minutesToAdd);

  // 4. Dùng lại hàm helper để định dạng và cập nhật model
  editableTask.value.thoiHan = toDatetimeLocalString(newDate);
};

// --- REF TASK
const availablePriorities = ref([
  { key: "URGENT", text: "Khẩn cấp" },
  { key: "HIGH", text: "Cao" },
  { key: "MEDIUM", text: "Trung bình" },
  { key: "LOW", text: "Thấp" },
]);
const editableTask = ref({
  title: "",
  description: "",
  priority: {},
  users: [],
  createdAt: null,
  guiThongBaoHangNgay: false,
});
const titleError = ref("");
const selectedTags = ref([]); // Mảng chứa các tag đang chọn
// CHANGED: Các computed properties mới dựa trên prop 'mode'
const isAddMode = computed(() => props.mode === "add");
const isEditMode = computed(() => props.mode === "edit");
const isViewMode = computed(() => props.mode === "view");

const modalTitle = computed(() => {
  if (isAddMode.value) return "Thêm Nhiệm vụ Mới";
  if (isEditMode.value) return "Chỉnh sửa Nhiệm vụ";
  if (isViewMode.value) return "Chi tiết Nhiệm vụ";
  return "";
});

const addTag = (newTag) => {
  selectedTags.value.push(newTag);
};

// onMounted(() => {
//   document.addEventListener("paste", handlePaste);
// });

onUnmounted(() => {
  document.body.classList.remove("modal-open");
  // document.removeEventListener("paste", handlePaste);
  if (editor.value) {
    editor.value.destroy();
  }
  if (editEditor.value) {
    editEditor.value.destroy();
  }
});

const togglePinComment = async (commentId) => {
  const comment = activities.value.find((c) => c.id === commentId);
  if (!comment) return;

  try {
    if (comment.isPinned) {
      // Nếu đang ghim -> Bỏ ghim
      await commentService.unpin(props.taskData.id, commentId);
      toast.success("Đã bỏ ghim bình luận.");
    } else {
      // Nếu chưa ghim -> Ghim
      await commentService.pin(props.taskData.id, commentId);
      toast.success("Đã ghim bình luận.");
    }
    await fetchComments(); // Tải lại danh sách
  } catch (error) {
    toast.error(error?.response?.data?.message || "Thao tác ghim thất bại.");
    console.error("Pin/Unpin error:", error);
  }
};

const sortedActivities = computed(() => {
  return [...activities.value].sort((a, b) => b.isPinned - a.isPinned);
});

const closeModal = () => emit("close");

// --- HÀM SỬ LÝ LƯU TASK
const handleSubmit = async () => {
  if (!editableTask.value.title.trim()) {
    titleError.value = "Tên nhiệm vụ không được để trống.";
    return;
  }
  titleError.value = "";

  // BƯỚC 1: UPLOAD CÁC FILE MỚI (NẾU CÓ)
  if (newlySelectedFiles.value.length > 0) {
    isUploading.value = true;
    try {
      const formData = new FormData();
      newlySelectedFiles.value.forEach((file) => {
        formData.append("files", file);
      });

      const folderName = `tasks`;
      formData.append("folderName", folderName);

      const uploadResponse = await fileService.upload(formData);

      // Map kết quả upload với thông tin file đã lưu từ trước
      const uploadedFileDtos = uploadResponse.data.map((res, index) => {
        const originalFile = newlySelectedFiles.value[index];
        return {
          originalFileName: originalFile.name,
          fileUrl: res.location, // URL từ API
          fileType: originalFile.type,
          fileSize: originalFile.size,
        };
      });

      // Thêm các file vừa upload vào danh sách attachments của task
      editableTask.value.attachments = [
        ...(editableTask.value.attachments || []),
        ...uploadedFileDtos,
      ];

      newlySelectedFiles.value = [];
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Tải file lên thất bại. Vui lòng thử lại."
      );
      console.error("File upload error:", error);
      isUploading.value = false;
      return;
    } finally {
      isUploading.value = false;
    }
  }

  // Chuyển mảng tags thành chuỗi cách nhau dấu phẩy để gửi backend
  const tagsString = selectedTags.value.join(",");

  emit("save", {
    ...editableTask.value,
    columnId: props.columnId,
    tags: tagsString,
  });

  closeModal();
};

// LOGIC BÌNH LUẬN
const newCommentText = ref("");
const editingCommentId = ref(null);
const editingCommentText = ref("");
const editingCommentAttachments = ref([]);
const me = ref([]);

// LOGIC ĐÍNH KÈM NHIỀU FILES
const fileInput = ref(null);
const attachedFiles = ref([]);
const attachmentPreviews = ref([]);

const triggerFileInput = () => {
  fileInput.value.click();
};

const handleFileChange = (event) => {
  for (const file of event.target.files) {
    attachedFiles.value.push(file);
    attachmentPreviews.value.push({
      name: file.name,
      type: file.type,
      url: URL.createObjectURL(file),
    });
  }
  event.target.value = "";
};

const removeAttachment = (index) => {
  URL.revokeObjectURL(attachmentPreviews.value[index].url);
  attachedFiles.value.splice(index, 1);
  attachmentPreviews.value.splice(index, 1);
};

// --- PHẦN COMMENT TRONG TASK
// LOGIC MENTION (@) TRONG COMMENT
const activities = ref([]);
const commentTextarea = ref(null);
const showMentionList = ref(false);
const mentionSearchTerm = ref("");
const mentionResults = computed(() => {
  if (!mentionSearchTerm.value) return [];
  return allUsers.value.filter((user) =>
    user.name.toLowerCase().includes(mentionSearchTerm.value.toLowerCase())
  );
});

// Phần bổ sung báo cáo trong comment

const filterType = ref("ALL"); // 'ALL', 'COMMENT', 'REPORT', 'PROPOSAL'
const actionType = ref("COMMENT"); // 'COMMENT', 'REPORT', 'PROPOSAL'
const currentPage = ref(0);
const totalPages = ref(0);
const totalElements = ref(0);
const pageSize = ref(20); // Số lượng comment trên mỗi trang
const activityFeedColumn = ref(null);

const displayedActivities = computed(() => sortedActivities.value);

watch(filterType, () => {
  currentPage.value = 0; // Reset về trang đầu khi đổi bộ lọc
  fetchComments();
});

// Logic hiển thị số trang cho pagination
const visiblePages = computed(() => {
  const pages = [];
  const maxVisible = 5;
  if (totalPages.value <= maxVisible + 2) {
    for (let i = 1; i <= totalPages.value; i++) pages.push(i);
  } else {
    pages.push(1);
    const current = currentPage.value + 1;
    let start = Math.max(2, current - Math.floor((maxVisible - 2) / 2));
    let end = Math.min(totalPages.value - 1, start + maxVisible - 3);
    start = Math.max(2, end - maxVisible + 3);

    if (start > 2) pages.push("...");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages.value - 1) pages.push("...");
    pages.push(totalPages.value);
  }
  return pages;
});

// HÀM ĐỂ CHUYỂN TRANG
const goToPage = (pageNumber) => {
  if (pageNumber >= 0 && pageNumber < totalPages.value) {
    currentPage.value = pageNumber;
    fetchComments();
    nextTick(() => {
      // Kiểm tra nếu ref đã được gắn vào element
      if (activityFeedColumn.value) {
        activityFeedColumn.value.scrollTop = 0; // Cuộn lên đầu
      }
    });
  }
};

const mapCommentType = (actionType) => {
  switch (actionType) {
    case "COMMENT":
      return "Thảo luận";
    case "REPORT":
      return "Báo cáo";
    case "PROPOSAL":
      return "Đề xuất";
    case "URGENT":
      return "Khẩn cấp";
    default:
      return "Tất cả";
  }
};

const getActivityItemClass = (item) => {
  return {
    "activity-item--report": item.type === "REPORT",
    "activity-item--proposal": item.type === "PROPOSAL",
  };
};

// const currentUser = ref({ id: 0, name: "User Hiện tại", avatarInitials: "ME" });

const toast = useToast();
const commentsLoading = ref(false);

// GỌI API COMMENT
const fetchComments = async () => {
  if (!props.taskData?.id) return;

  commentsLoading.value = true;
  try {
    const params = {
      page: currentPage.value,
      size: pageSize.value,
      type: filterType.value === "ALL" ? null : filterType.value, // Gửi null nếu là 'ALL'
    };
    if (getFocusCid()) {
      params.size = 999999;
    }

    const response = await commentService.getAllByTaskId(
      props.taskData.id,
      params
    );

    // Ánh xạ dữ liệu trả về từ API sang cấu trúc mà template đang sử dụng
    activities.value = response.data.content.map((comment) => ({
      id: Number(comment.id), // ⬅️ ép về number
      type: comment.type,
      user: {
        name: comment.author.hoTen,
        // Tạo avatar initials từ username
        avatar: comment.author.avatarUrl,
      },
      timestamp: formatTimestamp(comment.ngayTao), // Dùng lại hàm formatTimestamp của bạn
      timesupdate: formatTimestamp(comment.ngaySua),
      corrected: comment.ngayTao !== comment.ngaySua,
      content: comment.content,
      isPinned: comment.pinned,
      attachments: comment.attachments || [],
      workColumn: comment.workColumn || [],
      _original: comment, // Lưu lại dữ liệu gốc nếu cần
    }));
    totalPages.value = response.data.totalPages;
    totalElements.value = response.data.totalElements;
    await nextTick();
    tryFocusCommentOnce();
  } catch (error) {
    toast.error(error?.response?.data?.message || "Không thể tải bình luận.");
    console.error("Fetch comments error:", error);
    activities.value = []; // Xóa dữ liệu cũ nếu có lỗi
  } finally {
    commentsLoading.value = false;
  }
};

const handleCommentInput = (event) => {
  const text = event.target.value;
  const cursorPos = event.target.selectionStart;
  const textBeforeCursor = text.slice(0, cursorPos);
  const mentionMatch = textBeforeCursor.match(/@([\w\s]*)$/);

  if (mentionMatch) {
    mentionSearchTerm.value = mentionMatch[1];
    showMentionList.value = true;
  } else {
    showMentionList.value = false;
  }
};

const selectMention = (user) => {
  const text = newCommentText.value;
  const cursorPos = commentTextarea.value.selectionStart;
  const textBeforeCursor = text.slice(0, cursorPos);
  const textAfterCursor = text.slice(cursorPos);

  const mentionMatch = textBeforeCursor.match(/@([\w\s]*)$/);
  if (mentionMatch) {
    const startIndex = mentionMatch.index;
    const newText =
      textBeforeCursor.slice(0, startIndex) +
      `@${user.name} ` +
      textAfterCursor;
    newCommentText.value = newText;
  }
  showMentionList.value = false;
  commentTextarea.value.focus();
};

const addComment = async () => {
  const hasText = editor.value && !editor.value.isEmpty;
  const hasFiles = newlySelectedCommentFiles.value.length > 0;
  if (!hasText && !hasFiles) return; // Không làm gì nếu không có nội dung

  // !!! SỬA LỖI: THÊM VALIDATION Ở ĐÂY !!!
  // Backend yêu cầu CreateOrUpdateCommentDto phải có content (@NotEmpty),
  // nên frontend cũng phải tuân thủ quy tắc này.
  if (!hasText) {
    toast.error("Nội dung bình luận không được để trống.");
    return; // Dừng lại ngay lập tức, không upload file
  }

  isUploadingCommentFiles.value = true;
  const attachmentDtos = [];

  try {
    // 1. Upload file nếu có
    if (hasFiles) {
      const formData = new FormData();
      newlySelectedCommentFiles.value.forEach((file) =>
        formData.append("files", file)
      );
      const folderName = `tasks`;
      formData.append("folderName", folderName);

      const response = await fileService.upload(formData);

      // Tạo các DTO để gửi cho backend
      response.data.forEach((res, index) => {
        const originalFile = newlySelectedCommentFiles.value[index];
        attachmentDtos.push({
          originalFileName: originalFile.name,
          fileUrl: res.location,
          fileType: originalFile.type,
          fileSize: originalFile.size,
        });
      });
    }

    // 2. Tạo payload và gửi đi
    const payload = {
      content: editor.value.getHTML(),
      attachments: attachmentDtos,
      type: actionType.value,
    };

    await commentService.create(props.taskData.id, payload);

    toast.success("Đã thêm bình luận!");
    editor.value.commands.clearContent();
    newlySelectedCommentFiles.value = [];
    currentPage.value = 0;
    await fetchComments(); // Tải lại danh sách bình luận
  } catch (error) {
    toast.error(error?.response?.data?.message || "Thêm bình luận thất bại.");
    console.error("Add comment error:", error);
  } finally {
    isUploadingCommentFiles.value = false;
  }
};

const deleteComment = async (commentId) => {
  const result = await Swal.fire({
    title: `Bạn chắc chắn muốn xóa bình luận này"?`,
    html: "Hành động này sẽ <strong>xóa vĩnh viễn</strong> và không thể hoàn tác. <br/>Bạn có muốn tiếp tục?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Xóa vĩnh viễn!",
    cancelButtonText: "Hủy bỏ",
  });
  if (result.isConfirmed) {
    try {
      await commentService.deleteById(props.taskData.id, commentId);
      toast.success("Đã xóa bình luận.");
      await fetchComments(); // Tải lại danh sách
    } catch (error) {
      toast.error(error?.response?.data?.message || "Xóa bình luận thất bại.");
      console.error("Delete comment error:", error);
    }
  }
};

const startEdit = (comment) => {
  editingCommentId.value = comment.id;
  editingCommentAttachments.value = JSON.parse(
    JSON.stringify(comment.attachments || [])
  );
  if (editEditor.value) {
    editEditor.value.commands.setContent(comment.content);
    // Chờ Tiptap render xong rồi mới focus
    nextTick(() => {
      editEditor.value.commands.focus();
    });
  }
};

const saveEdit = async (comment) => {
  try {
    const payload = {
      content: editEditor.value.getHTML(),
      attachments: editingCommentAttachments.value,
      type: comment.type,
    };

    await commentService.update(props.taskData.id, comment.id, payload);
    toast.success("Cập nhật bình luận thành công.");
    cancelEdit(); // Thoát chế độ sửa
    await fetchComments(); // Tải lại danh sách
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Cập nhật bình luận thất bại."
    );
    console.error("Update comment error:", error);
  }
};

const cancelEdit = () => {
  editingCommentId.value = null;
  editingCommentAttachments.value = [];
  if (editEditor.value) {
    editEditor.value.commands.clearContent();
  }
};

// === (Định nghĩa extensions dùng chung) ===
const sharedExtensions = [
  StarterKit.configure({
    heading: false,
    blockquote: false,
    horizontalRule: false,
    codeBlock: false,
  }),
  Mention.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        id: {
          default: null,
          parseHTML: (element) => element.getAttribute("data-user-id"),
          renderHTML: (attributes) => {
            if (!attributes.id) return {};
            return { "data-user-id": attributes.id };
          },
        },
        label: {
          default: null,
          parseHTML: (element) => element.getAttribute("data-user-label"),
          renderHTML: (attributes) => {
            if (!attributes.label) return {};
            return { "data-user-label": attributes.label };
          },
        },
      };
    },
  }).configure({
    HTMLAttributes: {
      class: "mention-pill",
    },
    renderLabel({ node }) {
      return `@${node.attrs.label ?? "..."}`;
    },
    suggestion: {
      items: ({ query }) => {
        const source = mentionableUsers.value;
        return source
          .filter((user) =>
            user.hoTen.toLowerCase().includes(query.toLowerCase())
          )
          .slice(0, 5);
      },
      command: ({ editor, range, props }) => {
        editor
          .chain()
          .focus()
          .insertContentAt(range, [
            {
              type: "mention",
              attrs: {
                id: props.idNguoiDung,
                label: props.hoTen,
              },
            },
            { type: "text", text: " " },
          ])
          .run();
      },
      render: () => {
        let component;
        let popup;
        return {
          onStart: (props) => {
            component = new VueRenderer(MentionList, {
              props: props,
              editor: props.editor,
            });
            popup = tippy(document.body, {
              getReferenceClientRect: props.clientRect,
              appendTo: () => document.body,
              content: component.element,
              showOnCreate: true,
              interactive: true,
              trigger: "manual",
              placement: "bottom-start",
              arrow: false,
            });
          },
          onUpdate(props) {
            component.updateProps(props);
            if (popup) {
              popup.setProps({
                getReferenceClientRect: props.clientRect,
              });
            }
          },
          onKeyDown(props) {
            if (component.ref) {
              return component.ref.onKeyDown(props);
            }
            return false;
          },
          onExit() {
            if (popup) {
              popup.destroy();
            }
            if (component) {
              component.destroy();
            }
          },
        };
      },
    },
  }),
];
// ===============================================

// === @Tên ===
const editor = useEditor({
  content: "",
  extensions: sharedExtensions, // ⬅️ [SỬA] Dùng biến chia sẻ
  editorProps: {
    attributes: {
      class: "form-control tiptap-editor",
    },
  },
});

const editEditor = useEditor({
  content: "",
  extensions: sharedExtensions, // ⬅️ Dùng chung config
  editorProps: {
    attributes: {
      class: "form-control tiptap-editor",
    },
  },
});

// =====================

// HÀM HELPER CÁC CHỨC NĂNG KHÁC
const route = useRoute?.() || null; // an toàn: nếu file này không dùng router, vẫn chạy
const router = useRouter?.() || null;
const focusedOnce = ref(false); // để không highlight lặp lại

function getFocusCid() {
  const q = route.query || {};
  return q.commentId ?? q.focusComment ?? null;
}

async function tryFocusCommentOnce() {
  if (focusedOnce.value) return;
  const cidRaw = getFocusCid();
  if (!cidRaw) return;

  highlightedCommentId.value = Number(cidRaw); // để binding :class ăn ngay
  await nextTick(() => {
    setTimeout(() => {
      const cidStr = String(cidRaw);
      const el =
        document.querySelector(`[data-comment-id="${cidStr}"]`) ||
        document.getElementById(`comment-${cidStr}`);
      if (!el) return;

      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("comment--glow"); // phao thủ công
      setTimeout(() => el.classList.remove("comment--glow"), 2500);

      focusedOnce.value = true;

      // (tuỳ chọn) dọn query cho sạch
      const q = { ...route.query };
      delete q.commentId;
      delete q.focusComment;
      delete q.openTask;
      router.replace({ query: q }).catch(() => {});
    }, 150);
  });
}

// End hightlight comment

const formatTimestamp = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// SỰ KIỆN NHẤN ENTER ĐỂ GỬI COMMENT, SHIFT + ENTER XUỐNG DÒNG
const handleEnterKey = (event) => {
  // Kiểm tra xem phím được nhấn có phải là 'Enter'
  // và phím 'Shift' có đang được giữ hay không.
  if (event.key === "Enter" && !event.shiftKey) {
    // 1. Ngăn hành vi mặc định của phím Enter (là xuống dòng mới)
    event.preventDefault();

    // 2. Gọi hàm addComment để gửi bình luận
    addComment();
  }
};

// Sử lý lưu file

// const toast = useToast();
const taskFileInput = ref(null);
const newlySelectedFiles = ref([]); // Lưu các File object mới chọn
const isUploading = ref(false);

const triggerTaskFileInput = () => {
  taskFileInput.value.click();
};

const handleFileSelection = (event) => {
  addFiles(event.target.files); // Gọi hàm helper
  event.target.value = ""; // Reset input
};

const removeNewFile = (index) => {
  newlySelectedFiles.value.splice(index, 1);
};

// Xóa file đã tồn tại khỏi danh sách trên UI
// Backend sẽ lo phần xóa thật sự nhờ logic "synchronize"
const removeExistingAttachment = (attachmentToRemove) => {
  const index = editableTask.value.attachments.findIndex(
    (a) => a.fileUrl === attachmentToRemove.fileUrl
  );
  if (index > -1) {
    editableTask.value.attachments.splice(index, 1);
  }
};

// ==========================================================
// HỆ THỐNG XỬ LÝ FILE CHO BÌNH LUẬN
// ==========================================================
const commentFileInputRef = ref(null);
const newlySelectedCommentFiles = ref([]);
const isUploadingCommentFiles = ref(false);

const triggerCommentFileInput = () => {
  commentFileInputRef.value?.click();
};

const handleCommentFileSelection = (event) => {
  addCommentFiles(event.target.files); // Dùng helper mới
  event.target.value = ""; // Reset để có thể chọn lại file
};

const removeNewCommentFile = (index) => {
  newlySelectedCommentFiles.value.splice(index, 1);
};

// Phần hiển thị prevew ảnh
// THÊM: Các ref để quản lý lightbox
const lightboxVisible = ref(false);
const lightboxIndex = ref(0);
const lightboxImgs = ref([]);

// THÊM: Hàm để hiển thị lightbox
const showImagePreview = (attachments, clickedFile) => {
  // 1. Chỉ lọc ra các file là ảnh
  const images = attachments
    .filter((att) => att.fileType?.startsWith("image/"))
    .map((att) => ({
      src: att.fileUrl,
      title: att.originalFileName,
    }));

  if (images.length === 0) return;

  // 2. Tìm index của ảnh được click một cách trực tiếp và an toàn
  const correctIndex = images.findIndex(
    (img) => img.src === clickedFile.fileUrl
  );

  // 3. Hiển thị lightbox
  lightboxImgs.value = images;
  lightboxIndex.value = correctIndex >= 0 ? correctIndex : 0; // Đảm bảo index hợp lệ
  lightboxVisible.value = true;
};

// THÊM: Hàm để ẩn lightbox
const onHideLightbox = () => {
  lightboxVisible.value = false;
};

// THÊM: Hàm helper để lấy class icon cho file
const getFileIconClass = (fileType) => {
  if (!fileType) return "fa fa-file-o fa-2x text-muted";
  if (fileType.includes("pdf")) return "fa fa-file-pdf-o fa-2x text-danger";
  if (fileType.includes("word")) return "fa fa-file-word-o fa-2x text-primary";
  if (fileType.includes("excel"))
    return "fa fa-file-excel-o fa-2x text-success";
  return "fa fa-file-o fa-2x text-muted";
};

// ================ Phần sử lý kéo thả ảnh ===================
// --- Kéo thả ở phần task ---
const isDragOver = ref(false);

const addFiles = (fileList) => {
  if (!fileList || fileList.length === 0) return;

  for (const file of fileList) {
    // (Bạn có thể thêm kiểm tra loại file hoặc kích thước ở đây nếu muốn)
    newlySelectedFiles.value.push(file);
  }
};

// HÀM MỚI: Xử lý file từ kéo/thả
const handleFileDrop = (event) => {
  isDragOver.value = false;
  addFiles(event.dataTransfer.files);
};

// --- Kéo thả ở comment ---
const isCommentDragOver = ref(false);
// Hàm helper mới để xử lý file cho comment
const addCommentFiles = (fileList) => {
  if (!fileList || fileList.length === 0) return;

  for (const file of fileList) {
    newlySelectedCommentFiles.value.push(file);
  }
};

// Hàm xử lý file drop cho comment
const handleCommentFileDrop = (event) => {
  isCommentDragOver.value = false;
  addCommentFiles(event.dataTransfer.files);
};

// --- Xử lý file từ Dán (Paste) ---
// ===== BẮT ĐẦU THAY ĐỔI 1: CẬP NHẬT `handlePaste` =====
const handlePaste = (event) => {
  if (!props.show) return; // Không làm gì nếu modal đang đóng

  const files = event.clipboardData.files;

  // QUAN TRỌNG: Chỉ can thiệp (prevent) nếu CÓ FILE
  if (files && files.length > 0) {
    // Có file, ngăn trình duyệt dán text/path của file
    event.preventDefault();

    if (isViewMode.value) {
      // Nếu đang ở tab xem (có khu vực comment), dán file vào comment
      addCommentFiles(files);
      toast.success(`Đã dán ${files.length} file vào bình luận.`);
    } else {
      // Nếu đang ở tab Sửa/Thêm (không có khu vực comment), dán file vào task
      addFiles(files); // addFiles là hàm helper cho task (newlySelectedFiles)
      toast.success(`Đã dán ${files.length} file vào nhiệm vụ.`);
    }
  }
  // Nếu files.length === 0 (tức là đang dán text),
  // không làm gì cả (không gọi event.preventDefault()).
  // Trình duyệt sẽ tự động thực hiện hành vi dán text mặc định.
};

// Trong TaskModal.vue

const downloadFile = async (file) => {
  if (!file || !file.fileUrl) return;

  // 1. Kiểm tra xem có phải iOS không
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  // 2. Nếu là iOS, mở tab mới luôn (iOS ghét blob download ngầm)
  if (isIOS) {
    window.open(file.fileUrl, "_blank");
    return;
  }

  try {
    // Các dòng code cũ cho Android/PC giữ nguyên
    const response = await fetch(file.fileUrl, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
    });

    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.originalFileName || "downloaded-file");

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.warn("Không thể tải trực tiếp, chuyển sang mở tab mới", error);
    // Fallback cuối cùng
    window.open(file.fileUrl, "_blank");
  }
};
</script>

<style scoped>
/* --- Custom Circular Checkbox --- */
.task-checkbox {
  appearance: none;
  -webkit-appearance: none;
  background-color: #fff;
  margin: 0 0 0 5px;
  font: inherit;
  color: #adb5bd;
  width: 20px;
  height: 20px;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;
  flex-shrink: 0;
  transition: background-color 0.2s, border-color 0.2s;
}
.task-checkbox:hover {
  border-color: #007bff;
}
.task-checkbox::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  background-color: #28a745;
}
.task-checkbox:checked {
  border-color: #28a745;
}
.task-checkbox:checked::before {
  transform: scale(1);
}
/* Thêm của Lộc, hight cho comment */
/* tôn trọng người dùng muốn giảm chuyển động */
@media (prefers-reduced-motion: reduce) {
  .comment--glow,
  .comment--glow::after {
    animation: none !important;
    transition: none !important;
  }
}

.comment--glow {
  position: relative;
  isolation: isolate;
  background: rgba(255, 200, 0, 0.1);
  border-radius: 10px;
  transition: background 300ms ease;
}
.comment--glow::after {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 12px;
  pointer-events: none;
  z-index: 1;
  box-shadow: 0 0 0 0 rgba(255, 200, 0, 0.65);
  animation: pulseRing 1600ms ease-out 3;
}
.comment--glow .card-body {
  position: relative;
  z-index: 2;
}

@keyframes pulseRing {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 200, 0, 0.65);
  }
  60% {
    box-shadow: 0 0 0 10px rgba(255, 200, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0px rgba(255, 200, 0, 0);
  }
}

/* CSS không thay đổi, giữ nguyên như cũ */
body.modal-open {
  overflow: hidden;
}
.modal.show {
  display: block;
}
.modal-body.d-flex {
  padding: 0 1rem !important;
  max-height: 75vh;
}
.task-details-column,
.activity-feed-column {
  overflow-y: auto;
  height: 100%;
  padding: 1.5rem;
}
@media (max-width: 991px) {
  .task-details-column,
  .activity-feed-column {
    height: auto;
  }
}
.activity-feed-column {
  background-color: #f8f9fa;
}
.comment-input-wrapper {
  position: relative;
}
.mention-list {
  position: absolute;
  z-index: 1080;
  width: 100%;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.attachment-preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.attachment-preview {
  position: relative;
  display: inline-block;
}
.attachment-preview .img-thumbnail {
  max-width: 100px;
  max-height: 80px;
  object-fit: cover;
}
.attachment-remove-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  line-height: 24px;
}
.user-search-container {
  position: relative;
}
.user-search-results {
  position: absolute;
  width: 100%;
  z-index: 1071;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: white;
}
.avatar > img {
  height: 100%;
}
.avatar-placeholder {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}
.assigned-user-tag {
  display: inline-flex;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 16px;
  padding: 4px 8px;
  font-size: 0.875rem;
  margin-right: 5px;
  margin-bottom: 5px;
}
.avatar-sm {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
}
.assigned-user-tag .fa-times-circle {
  margin-left: 8px;
  cursor: pointer;
}
.comment-content.card {
  background-color: #ffffff;
  /* border: none; */
  border-radius: 20px;
}
/* video comment */
.comment-attachment-video {
  width: 100%;
}
/* Màu viền cho từng loại */
.activity-item--report {
  border-left-color: #28a745;
  border-right-color: #28a745;
  border-width: 4px;
}
.activity-item--proposal {
  border-left-color: #ffc107;
  border-right-color: #ffc107;
  border-width: 4px;
}
.comment-content.card.pinned {
  background-color: #d4e8ff;
}
.comment-actions .btn-light {
  border: 1px solid #ddd;
}
.file-attachment,
.file-preview {
  padding: 8px;
  background: #f1f3f5;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  font-size: 0.8rem;
}
.comment-content {
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
}
.action-links a {
  color: #979797;
}
/* Style cho grid preview */
.attachment-previews-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
}

.attachment-preview-item {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #dee2e6;
}

.attachment-thumbnail {
  cursor: pointer;
}

.attachment-thumbnail img,
.attachment-thumbnail video {
  width: 100%;
  height: 90px;
  object-fit: cover;
  display: block;
}

.file-icon-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 90px;
  background-color: #f8f9fa;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  color: #495057;
}

.file-icon-preview .file-name {
  font-size: 11px;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.attachment-remove-btn {
  position: absolute;
  top: -5px;
  right: -5px;
  background: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  line-height: 18px;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  color: red;
  border: none;
}

/* Tag hiển thị loại */
.activity-tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  border-radius: 10px;
  margin-left: 8px;
  vertical-align: middle;
}
.activity-tag-report {
  background-color: #e9f9ee;
  color: #28a745;
}
.activity-tag-proposal {
  background-color: #fff8e1;
  color: #f57c00;
}
.activity-tag-urgent {
  background-color: #fff8e1;
  color: #f50000;
}

/* BỔ SUNG: CSS cho khu vực Kéo/Thả File */

.file-drop-zone {
  border: 2px dashed #ced4da;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  background-color: #f8f9fa;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.file-drop-zone p {
  margin-bottom: 10px;
  color: #6c757d;
  font-size: 0.9rem;
}
.file-drop-zone:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
/* Trạng thái khi người dùng kéo file vào */
.file-drop-zone.drag-over {
  background-color: #e9ecef;
  border-color: #007bff;
}

.file-drop-zone .btn-light {
  border: 1px solid #ccc;
}
/* Style cho khung Tiptap */
:deep(.tiptap-editor) {
  min-height: 60px;
  padding: 8px 12px;
  max-height: 250px;
  height: auto !important;
  overflow-y: auto;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
}
:deep(.tiptap-editor:focus) {
  outline: 0;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
/* Style cho placeholder */
:deep(.tiptap-editor p.is-editor-empty:first-child::before) {
  content: "Viết bình luận, gõ @ để nhắc tên...";
  float: left;
  color: #adb5bd;
  pointer-events: none;
  height: 0;
}
/* Style cho "viên thuốc" @mention */
:deep(.mention-pill) {
  background-color: #e0eaff;
  color: #0056b3;
  padding: 1px 5px;
  border-radius: 4px;
  font-weight: 600;
  white-space: nowrap;
}
:deep(.tiptap-editor p) {
  margin-bottom: 0; /* Loại bỏ khoảng trắng dưới mỗi dòng */
  margin-top: 0; /* Loại bỏ khoảng trắng trên (đề phòng) */
  min-height: 1.5em; /* Giữ chiều cao tối thiểu để dòng trống vẫn hiển thị được */
}
:deep(.tiptap-editor p),
:deep(.comment-content p) {
  margin-bottom: 0; /* Loại bỏ khoảng trống lớn phía dưới */
  margin-top: 0;
  min-height: 1.2rem; /* Đảm bảo dòng trống vẫn có chiều cao để hiển thị */
}
/* Đảm bảo thẻ bao ngoài có vị trí tương đối để con neo theo */
.attachment-preview-item,
.comment-attachment > div {
  position: relative;
}

/* --- CSS CHO CỤM NÚT HÀNH ĐỘNG (SHARE + DOWNLOAD) --- */

/* Container bao quanh các nút ở góc dưới phải */
.file-actions-overlay {
  position: absolute;
  bottom: 5px;
  right: 5px;
  display: flex;
  gap: 6px; /* Khoảng cách giữa nút Share và Download */
  z-index: 10;
  opacity: 0; /* Ẩn mặc định */
  transition: opacity 0.2s ease;
}

/* Hiện container khi hover vào file */
.attachment-preview-item:hover .file-actions-overlay,
.comment-attachment > div:hover .file-actions-overlay {
  opacity: 1;
}

/* Style chung cho nút Share và Download */
.btn-file-action {
  width: 28px; /* Tăng nhẹ kích thước cho dễ bấm */
  height: 28px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #495057;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  text-decoration: none; /* Cho thẻ a */
  padding: 0;
}

.btn-file-action i {
  font-size: 14px;
}

/* Hiệu ứng khi hover vào từng nút */
.btn-file-action:hover {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
  transform: translateY(-2px);
}

/* Riêng nút Share có màu xanh khi chưa hover để phân biệt (Tuỳ chọn) */
.btn-share-action {
  color: #007bff;
}
.btn-share-action:hover {
  color: white;
}

/* Trên Mobile luôn hiển thị */
@media (max-width: 1200px) {
  .file-actions-overlay {
    opacity: 1;
    background: transparent;
  }
  .btn-file-action {
    background-color: rgba(255, 255, 255, 0.95);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }
}

/* Điều chỉnh nút Xóa (góc trên phải) để không bị đè */
.attachment-remove-btn {
  z-index: 11; /* Cao hơn layer actions */
}
.bg-light {
  background-color: #f8f9fa !important;
}
.date-picker-container {
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btn-xs {
  padding: 1px 5px;
  font-size: 10px;
  line-height: 1.5;
  border-radius: 3px;
}
</style>
